// LIBRARIES
import styled from "styled-components";
import { CircularProgress } from "@mui/material";

// MISC
import { COLORS, WIDTH } from "constants/styleVariables";

export const DashboardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  min-width: 620px;
  height: 100%;
  background-color: ${COLORS.backgroundColor};
  @media (${WIDTH.smallWidth}) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const LodingSign = styled(CircularProgress)`
  && {
    justify-content: center;
    align-items: center;
    // margin-top: 60px;
    margin-left: auto;
    margin-right: auto;
    color: ${COLORS.rainbowIndigo};
    opacity: 1 !important;
  }
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
